// extracted by mini-css-extract-plugin
export var circle = "_fk-1";
export var exitConfirmationModal = "_fk-5";
export var iframe = "_fk-0";
export var offline = "_fk-3";
export var online = "_fk-2";
export var workstationSelectError = "_fk-4";